import BookingForm from "../components/sections/BookingForm";
import ContactSection from "../components/sections/ContactSection";

const ContactPage = () => {
  return (
    <main data-testid="contact-page" className="bg-white">
      <section className="pt-32 md:pt-40 pb-12 md:pb-16 bg-slate-50/60 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
            Contact
          </div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-light text-slate-900 max-w-3xl leading-[1.05]">
            Let's get your space{" "}
            <span className="font-medium">spotless.</span>
          </h1>
          <p className="mt-5 text-slate-600 max-w-2xl leading-relaxed">
            Tell us a few details and a team member will reach out with a fast,
            no-obligation quote. Limited slots available this week.
          </p>
        </div>
      </section>

      <BookingForm />
      <ContactSection />
    </main>
  );
};

export default ContactPage;
